export const myTeamTracker = {
  events: {
    accessMyTeam: 'Acessar Meu Time',
  },
}
